import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AbstractEnrollmentService } from '../../abstracts/services/onboarding/enrollment.abstract';
import { IApiResponse } from '../../interfaces/api/api-response.interface';
import { IAppState } from '../../store/common/interfaces/app-state.interface';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentService extends AbstractEnrollmentService {
  private apiUrl = environment.apiUrl;
  private controllerSuffix = 'Onboarding/Onboarding/';
  constructor(private httpClient: HttpClient, private store: Store<IAppState>) {
    super();
  }
  async submitBusinesType(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitBusinessIndustry(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitCustomerType(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitStateofOrg(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitDBA(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitCompanyAddress(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitAnnualRevenue(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitCompanyWebsite(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitYearFounded(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitNumberOfEmployees(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitInvoiceMethod(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async submitLendingMethod(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async confirmDetails(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }

  async confirmCompanyMatch(model: unknown): Promise<IApiResponse> {
    const body = {
      model,
    };
    return firstValueFrom(
      this.httpClient.post<IApiResponse>(
        `${this.apiUrl}${this.controllerSuffix}tell-us`,
        body
      )
    );
  }
}
